import { format } from "date-fns";
import { enUS, fr, de, es } from "date-fns/locale";
import { getLocale } from "../../i18n/runtime";

const dateLocales = { en: enUS, fr, de, es };

export function formatDate(date, formatStr = "PP") {
  return format(date, formatStr, { locale: dateLocales[getLocale()] });
}
